export class HttpError extends Error {
  response: {
    data: any;
    status: number;
    headers: Record<string, unknown>;
  };

  // El constructor debe aceptar los 3 parámetros: message, status, y data.
  constructor(message: string, status: number, data: any, headers: Record<string, unknown> = {}) {
    super(message); // Llama al constructor de la clase base 'Error'
    this.name = 'HttpError';

    // Asigna las propiedades a la instancia
    this.response = {
      data,
      status,
      headers,
    };
  }
}
